import React, { Component } from 'react';
import { Route, Redirect, Switch } from 'react-router';
import SharedPageView from '../../views/SharedPage';
import ImprintDetailsView from '../../views/Imprint/Details';
import ArtistProfileView from '../../views/Artist/Profile';
import ProjectDetailsView from '../../views/Project/Details';
import ProductDetailsView from '../../views/Product/Details';
import TrackDetailsView from '../../views/Track/Details';
import MainView from '../../views/Home';
import TerritoriesListView from '../../views/Territories/List';
import AudienceOverviewView from '../../views/Audience/Overview';
import ComparisonListView from '../../views/Comparison/List';
import WithUser from '../../helpers/WithSharedUser';

const WithUserImprintDetailsView = WithUser(ImprintDetailsView);
const WithUserArtistProfileView = WithUser(ArtistProfileView);
const WithUserProjectDetailsView = WithUser(ProjectDetailsView);
const WithUserProductDetailsView = WithUser(ProductDetailsView);
const WithUserTrackDetailsView = WithUser(TrackDetailsView);
const WithUserMainView = WithUser(MainView);
const WithUserAudienceOverviewView = WithUser(AudienceOverviewView);
const WithUserComparisonListView = WithUser(ComparisonListView);
const WithUserTerritoriesListView = WithUser(TerritoriesListView);

const unauthorized=(props)=>{
    return <Switch>
        <Route path="/share/imprints/:id/:name?" render={(props)=><WithUserImprintDetailsView sharedMode={true} {...props} />}></Route>
        <Route path="/share/artists/:id/:name?" render={(props)=><WithUserArtistProfileView sharedMode={true} {...props} />}></Route>
        <Route path="/share/projects/:id/:name?" render={(props)=><WithUserProjectDetailsView sharedMode={true} {...props} />}></Route>
        <Route path="/share/products/:id/:name?" render={(props)=><WithUserProductDetailsView sharedMode={true} {...props} />}></Route>
        <Route path="/share/tracks/:id/:name?" render={(props)=><WithUserTrackDetailsView sharedMode={true} {...props} />}></Route>
        <Route path="/share/main/" render={(props)=><MainView sharedMode={true} {...props} />}></Route>
        <Route path="/share/audience/:entity/:id" render={(props)=><AudienceOverviewView sharedMode={true} {...props} />}></Route>
        <Route path="/share/comparison/:type/:entities" render={(props)=><WithUserComparisonListView sharedMode={true} {...props} />}></Route>
        <Route path="/share/territories/:continent?" render={(props)=><WithUserTerritoriesListView sharedMode={true} {...props} />}></Route>
        <Route path="/share/:slug" component={SharedPageView}></Route>
    </Switch>
    
    }

export default unauthorized; 